import { css } from '@emotion/react';
import Skeleton from 'react-loading-skeleton';

import { theme } from '../theme';

const styles = {
  passenger: css`
    @media (max-width: ${theme.breakpoints.laptop}) {
      order: 2;
      font-size: 14px;
    }
  `,
};

type PassengersCompactProps = {
  passengerLabel: string | undefined;
  loading?: boolean;
};

export function PassengersCompact({ loading = false, passengerLabel }: PassengersCompactProps) {
  return <div css={styles.passenger}>{loading ? <Skeleton style={{ width: 60 }} /> : passengerLabel}</div>;
}
